import type {
	ChatMessage,
	ConversationSummary,
	ConversationTransferNotification,
} from '@livechat/shared';

export interface ChatToast {
	conversationId: string;
	detail: string;
	id: string;
	kind: 'new-chat' | 'new-message' | 'transferred-chat';
	title: string;
}

export function transferredChatToast(notification: ConversationTransferNotification): ChatToast {
	return {
		conversationId: notification.conversation.id,
		detail: `${notification.conversation.visitorName ?? 'Visitor'} · transferred by ${notification.fromAgentName}`,
		id: `transferred-chat-${notification.conversation.id}`,
		kind: 'transferred-chat',
		title: 'Transferred chat connected',
	};
}

export function isAssignedVisitorMessage(
	message: ChatMessage,
	conversation: ConversationSummary | undefined,
	userId: string,
): boolean {
	return message.senderType === 'visitor' && conversation?.assignedUserId === userId;
}

export function newChatToast(conversation: ConversationSummary): ChatToast {
	return {
		conversationId: conversation.id,
		detail: conversation.departmentName
			? `${conversation.visitorName ?? 'Visitor'} · ${conversation.departmentName}`
			: (conversation.visitorName ?? 'Visitor'),
		id: `new-chat-${conversation.id}`,
		kind: 'new-chat',
		title: 'New customer waiting',
	};
}

export function newMessageToast(
	message: ChatMessage,
	conversation?: ConversationSummary,
): ChatToast {
	const sender = message.senderName ?? conversation?.visitorName ?? 'Visitor';
	const body = message.body?.trim();
	const preview = body && body.length > 72 ? `${body.slice(0, 69)}…` : body;
	return {
		conversationId: message.conversationId,
		detail: preview ? `${sender}: ${preview}` : `${sender} sent a message`,
		id: `new-message-${message.id}`,
		kind: 'new-message',
		title: 'New message received',
	};
}
